import { ComponentApi } from 'api';
import { apiCallStatus } from 'helpers/constants';
import { actionTypes, commonActionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';
import { actionTypes as opActionTypes } from './OperationalParametersV2/constants';

const getAssetDetailsAction = getApiActionCreator(actionTypes.GET_ASSET_DETAILS);

export const getAssetDetailsV2 = (assetID) => {
    return (dispatch) => {
        dispatch(getAssetDetailsAction(apiCallStatus.LOADING));
        ComponentApi.getAssetDetailsV2({ id: assetID })
            .then(details => {
                dispatch(getAssetDetailsAction(apiCallStatus.SUCCESS, { ...details, details: { ...details?.details } }));
            }, (err) => {
                dispatch(getAssetDetailsAction(apiCallStatus.ERROR, null, err));
            });

    };
};
export const setActiveTab = (activeTab) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SET_ACTIVE_TAB, activeTab });
    };
};
export const setActiveTabV2 = (activeTab) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SET_ACTIVE_TAB_V2, activeTab });
    };
};
export const setAssetConditionInsightStatus = (conditionInsightStatus) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SET_SELECTED_ASSET_CONDITION_INSIGHTS_STATUS, conditionInsightStatus });
    };
};
export const clearStore = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_STORE });
    };
};

export const clearDownloadMeasurementStore = () => {
    return (dispatch) => {
        dispatch({ type: commonActionTypes.CLEAR_STORE });
    };
};

export const clearOperationalParametersApiErrors = () => {
    return (dispatch) => {
        dispatch({ type: opActionTypes.CLEAR_OPERATIONAL_PARAMETERS_API_ERRORS });
    };
};
